const isType = (transaction: string, type: string): boolean => {
  return transaction?.includes(type) || false
}
export default isType
